/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm } from '@insticator/insticator-ui'


/* ++++++++++ --------------- EXPORT : COMMENTING CONFIGURATION ADMIN SECTION : STYLES --------------- ++++++++++ */
export default theme => ({
  actionbuttons: {
   marginTop: pxToEm(16),
   '& .name-savedraft': {
      width: pxToEm(156)
   }
  }
});
